var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeed2X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M8 10h28v24H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.094 25.96V28h-7.696a5.3 5.3 0 0 1 .75-2.191c.417-.69 1.24-1.606 2.47-2.747.989-.921 1.596-1.546 1.82-1.875.302-.453.453-.9.453-1.343 0-.49-.132-.866-.395-1.13-.263-.262-.626-.394-1.09-.394-.458 0-.823.138-1.093.414-.271.276-.428.735-.47 1.375l-2.187-.218c.13-1.209.54-2.076 1.227-2.602.687-.526 1.547-.789 2.578-.789 1.13 0 2.018.305 2.664.914.646.61.969 1.367.969 2.273 0 .516-.093 1.007-.278 1.473-.184.466-.477.955-.878 1.465-.266.339-.745.826-1.438 1.46-.693.636-1.132 1.058-1.316 1.267a3.79 3.79 0 0 0-.45.609h4.36zm.898 2.04 2.992-4.273-2.867-4.024h2.68l1.469 2.281 1.547-2.28h2.578l-2.813 3.929L30.648 28h-2.695l-1.687-2.57L24.563 28h-2.57z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed2X);
export default __webpack_public_path__ + "static/media/speed2X.75f92e570721490e75c30719e0dc1c94.svg";
export { ForwardRef as ReactComponent };